<template>
  <component :is="tag"
             :type="nativeType"
             class="btn"
             :class="classes"
             @click="$emit('click')">
    <span class="btn-label" v-if="$slots.label">
      <slot name="label"></slot>
    </span>
    <template v-if="nprogress">
      {{nprogressLabel || label}}
      <i
        class="mini-loader fas fa-spinner mr-1"
      />
    </template>
    <template v-else>
      <i v-if="iconLeft" :class="[iconLeft]"></i> {{label}} <i v-if="iconRight" :class="[iconRight]"></i>
    </template>
    <slot></slot>
    <span class="btn-label btn-label-right" v-if="$slots.labelRight">
      <slot name="labelRight"></slot>
    </span>
  </component>
</template>
<script>
  export default {
    name: 'n-button',
    props: {
      tag: {
        type: String,
        default: 'button'
      },
      type: {
        type: String,
        default: 'default'
      },
      nativeType: {
        type: String,
        default: 'button'
      },
      label: {
        type: String,
        default: '',
      },
      nprogressLabel: {
        type: String,
        default: '',
      },
      nprogress: {
        type: Boolean,
        default: false,
      },
      iconRight: {
        type: String,
        default: '',
      },
      iconLeft: {
        type: String,
        default: '',
      },
      round: Boolean,
      simple: Boolean,
      block: Boolean,
      social: Boolean,
      link: Boolean,
      icon: Boolean,
      wide: Boolean,
      size: String
    },
    computed: {
      classes() {
        let btnClasses = [
          {'btn-simple': this.simple},
          {'btn-icon': this.icon},
          {'btn-round': this.round},
          {'btn-block': this.block},
          {'btn-social': this.social},
          {'btn-link': this.link},
          {'btn-wd': this.wide},
          `btn-${this.type}`
        ];
        if (this.size) {
          btnClasses.push(`btn-${this.size}`)
        }
        return btnClasses
      }
    }
  }
</script>
<style>
</style>
